import { PrimaryTab, Tabs } from '@grays-npm/component-library';
import { NavLink, Route, Routes, Navigate } from 'react-router-dom';
import styled from 'styled-components';
import { ListingsTab } from '../../components';
import { useCMSData } from '../../state/content-manager';
import { ListingsContextProvider } from '../../state/listings/ListingsContext';
import { ListingsModal, useListingsModal } from './ListingsModal';
import { ListingTabView } from './ListingTabView';

export type TabItem = {
  title: string;
  type: ListingsTab;
  href: string;
  disabled?: boolean;
  hidden?: boolean;
  emptyText?: string;
  emptyDescription?: string;
};

const Link = styled(NavLink)<{ disabled: boolean }>`
  ${({ disabled }) => disabled && `pointer-events: none;`}
`;

export const Listings = () => {
  const cmsData = useCMSData();
  const tabItems = cmsData?.listings.tabs;

  const handleAuctionDataClick = () => {
    //TODO: implement fetching relevant auction data for displaying in modal, eg bid / offer history
  };

  const handlePromoteClick = () => {
    //TODO: implement promoting listing.
  };

  const handleReviewClick = () => {
    //TODO: implement reviewing listing.
  };

  const modalState = useListingsModal();

  return (
    <ListingsContextProvider
      value={{
        handlers: {
          setModalContent: modalState.setContent,
          auctionData: handleAuctionDataClick,
          review: handleReviewClick,
          promote: handlePromoteClick,
        },
      }}
    >
      <Routes>
        <Route path="/" element={<Navigate to="active" replace />} />
        {tabItems?.map((tabItem) => (
          <Route
            path={tabItem.href}
            key={tabItem.type}
            element={
              <ListingTabView
                topChildren={
                  <Tabs>
                    {tabItems?.map(
                      (tabItem) =>
                        !tabItem.hidden && (
                          <PrimaryTab
                            key={tabItem.title}
                            disabled={tabItem.disabled}
                          >
                            <Link
                              disabled={!!tabItem.disabled}
                              to={`..${tabItem.href}`}
                            >
                              {tabItem.title}
                            </Link>
                          </PrimaryTab>
                        )
                    )}
                  </Tabs>
                }
                tabItem={tabItem}
                refetchData={modalState.isApiSuccess}
              />
            }
          />
        ))}
      </Routes>
      <ListingsModal {...modalState} />
    </ListingsContextProvider>
  );
};
